export { default as InventoryListTemplate } from './InventoryList';
